
import Vue from 'vue';
import VueMarkdown from '@adapttive/vue-markdown';
import katex from '@iktakahiro/markdown-it-katex';
import { TextModel } from '@descomplica/dex-models';

export default Vue.extend({
  components: {
    VueMarkdown,
  },
  props: {
    content: {
      type: TextModel,
      required: true,
    },
    trustedContent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      plugins: [
        {
          plugin: katex,
          options: { throwOnError: false },
        },
      ],
    };
  },
});
